import './app.css';



/* is production */
const isProd = process.env.NODE_ENV === 'production';



/* meta */
const meta = require('./js/meta.json');

/* data [UNCOMMENT THE LINE BELOW TO USE TEXTS FROM DATA IN JS] */
// const data = require('./js/data.json');



/* analytics */
/* SEND EVENT: analyticsEvent('Button', 'click', 'Play'); */

const analyticsEvent = (category, action, label) => {
    const dataLayer = window.dataLayer = window.dataLayer || [];

    dataLayer.push({
        'event': 'eventTracking',
        'category': category,
        'action': action,
        'label': label
    });
};

/* track events from html attributes */
const trackingElements = document.querySelectorAll('[data-event][data-event-category][data-event-label]');

if (trackingElements.length > 0) {
    trackingElements.forEach(trackingElem => {
        trackingElem.addEventListener(trackingElem.getAttribute('data-event'), () => {
            analyticsEvent(
                trackingElem.getAttribute('data-event-category'),
                trackingElem.getAttribute('data-event'),
                trackingElem.getAttribute('data-event-label')
            );
        });
    });
}

analyticsEvent('Page', 'load', 'Success');



/* fonts */
const WebFont = require('webfontloader');

WebFont.load({
    /* CUSTOM FONTS
    Uncomment this and at webpack.config.js
    custom: {
        families: ['Proxima Nova:n3,n4'],
        urls: ['./css/fonts.css']
    },
    */
    google: {
        families: ['Roboto:300,400,500,700,900:cyrillic']
    }
});


let slider;

/* share */
import * as VanillaSharing from 'vanilla-sharing';

const shareButtons = [...document.querySelectorAll('.share__item')];

if (shareButtons.length > 0) {

    const shareUrl = meta.share;
    const shareOptions = {
        url: shareUrl,
        title: meta.title,
        description: meta.description,
        image: meta.image,
        isVkParse: false,
        fbAppId: meta.fbappid
    };

    const updateShareOptions = () => {
        if (!slider) return;
        let name = slider.getSlideName() || 'intro';
        const map = {
            "intro": {
                "title":  "Как я провел этим годом",
                "description":  "Годовой отчёт 2017. Всё самое главное — от Трампа до Вайнштейна и биткоина",
                "image":  "img/og/share_01.jpg"
            },
            "01": {
                "title":  "Дональд Трамп",
                "description":  "Дональд Трамп вступил в должность президента США. Это было предсказано в «Симпсонах» ещё в 2000 году",
                "image":  "img/og/share_01.jpg"
            },
            "02": {
                "title":  "Фильм года \"Лунный свет\"",
                "description":  "Состоялась 89-я церемония вручения премии «Оскар». Американская киноакадемия признала фильмом года драму «Лунный свет», рассказывающую о взрослении чернокожего подростка-гея. Лидером по числу номинаций (14) был музыкальный фильм «Ла-Ла Ленд»",
                "image":  "img/og/share_02.jpg"
            },
            "03": {
                "title":  "SpaceX. Повторный запуск и повторная посадка модуля",
                "description":  "SpaceX впервые осуществила успешный повторный запуск и повторную посадку уже летавшей первой ступени",
                "image":  "img/og/share_03.jpg"
            },
            "04": {
                "title":  "Ушёл из жизни Евгений Евтушенко",
                "description":  "Умер Евгений Евтушенко, последний из плеяды знаменитых советских поэтов-шестидесятников, представитель той эпохи, когда поэты собирали целые стадионы поклонников",
                "image":  "img/og/share_04.jpg"
            },
            "05": {
                "title":  "Спартак - чемпион!",
                "description":  "Московский «Спартак» впервые с 2001 года стал чемпионом России по футболу. Таким образом «самая народная» команда стала десятикратным чемпионом страны",
                "image":  "img/og/share_05.jpg"
            },
            "06": {
                "title":  "Атака Wanna Cry",
                "description":  "12 мая началось массовое распространение сетевого червя Wanna Cry и Petya, особенно затронувшее Россию и Украину. В общей сложности, от червя пострадало более 500 тысяч компьютеров",
                "image":  "img/og/share_06.jpg"
            },
            "07": {
                "title":  "Закрыт RAMP",
                "description":  "Закрыт RAMP (Russian Anonymous Marketplace) — крупнейший в стране интернет-магазин наркотиков",
                "image":  "img/og/share_07.jpg"
            },
            "08": {
                "title":  "Рэп-баттл Оксимироном vs Гнойный",
                "description":  "Oxxxymiron, который до этого неизменно выходил из батлов Versus победителем, на этот раз проиграл Гнойному со счётом 5:0",
                "image":  "img/og/share_08.jpg"
            },
            "09": {
                "title":  "Хью Хефнер скончался",
                "description":  "В возрасте 91 года умер Хью Хефнер, основатель и шеф-редактор журнала «Playboy». Вот уж у кого точно была счастливая жизнь",
                "image":  "img/og/share_09.jpg"
            },
            "10": {
                "title":  "Секс-скандалю. Харви Вайнштейн",
                "description":  "Интервью актрисы Эшли Джадд, рассказавшей о домогательствах со стороны Харви Вайнштейна, послужило отправной точкой крупнейшего в истории секс-скандала",
                "image":  "img/og/share_10.jpg"
            },
            "11": {
                "title":  "100-летие Октябрьской революции",
                "description":  "Спустя столетие Россия ещё не вполне избавилась от последствий этой травмы, о чём свидетельствовала юбилейная невнятица",
                "image":  "img/og/share_11.jpg"
            },
            "12": {
                "title":  "Биткоин 20 000 долларов",
                "description":  "17 декабря курс биткоина преодолел отметку в 20 000 долларов. Но это, видимо, был пик успеха — в 2018 году курсы криптовалют пошли вниз",
                "image":  "img/og/share_12.jpg"
            }
        };
        
        shareOptions.url = shareUrl + (name === 'intro' ? '' : '?p=' + name);
        shareOptions.title = shareUrl + map[name]['title'];
        shareOptions.description = shareUrl + map[name]['description'];
        shareOptions.image = shareUrl + map[name]['image'];
    };

    shareButtons.forEach(button => {
        button.addEventListener('click', () => {
            updateShareOptions();
            if (button.dataset.social === 'all' && navigator.share !== undefined) {
                navigator.share({
                    title: shareOptions.title,
                    url: shareOptions.url
                });
            } else {
                VanillaSharing[button.dataset.social](shareOptions);
            }

            analyticsEvent('Share', 'click', 'Social: ' + button.dataset.social + ' - ' + slider.getSlideName());
        });
    });

}



/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}



/* jquery [UNCOMMENT THE LINE BELOW TO USE JQUERY IN JS] */
// window.$ = window.jQuery = require('jquery');


import socialstat from './js/socialstat';

if (document.querySelector('.socialstat')) {
    socialstat();
}

if (document.getElementById("menu")) {
    require('./js/menu');
}

if (document.getElementById("synopsis-open")) {
    require('./js/synopsis');
}

if (document.getElementById("svg-animation")) {
    require('./js/bg-animation');
}

// if (document.getElementById("canvas-animation")) {
//     require('./js/bg-canvas');
// }

if (document.getElementById("scene")) {
    slider = require('./js/slider');
    slider.setAnalyticsFunction(analyticsEvent);
}

if (document.getElementById("sound-button")) {
    require('./js/sound');    
}





// WEBPACK FOOTER //
// ./app.js